<span #tooltip class="tooltip tooltip--position-{{ position }}" [ngClass]="{ 'tooltip--active': active, 'tooltip--max-z-index': zIndex === 'max' }" [ngStyle]="{ top: top, bottom: bottom, left: left }">
  <ng-content></ng-content>
  {{ content }}
  <span class="tooltip__arrow" [ngStyle]="{ left: arrowOffset + 'px' }"></span>
</span>
